<template>
  <div class="seckill-good" @click="onGoSpike(ssu)">
    <div class="seckill-good-image">
      <div class="image">
        <GoodImage
          :img-url="
            sku.skuImg.imgUrl | ossImage(180, 180, 'contain') | ossHttpVersion
          "
          :width="'66px'"
          :height="'66px'"
          :fit="'cover'"
        ></GoodImage>
      </div>
      <div v-if="sku.skuImg.cmsRightUpperTag" class="img-tag">
        {{ sku.skuImg.cmsRightUpperTag }}
      </div>
      <div v-if="sku.skuImg.leftBottomTag[0]" class="img-leftBottomTag tags">
        <tag
          has-border
          has-background
          :primary-color="sku.skuImg.leftBottomTag[0].textColor"
          :secondary-color="sku.skuImg.leftBottomTag[0].frame_color"
          :corner-radius="sku.skuImg.leftBottomTag[0].corner_radius"
          :bg-color="sku.skuImg.leftBottomTag[0].backgroundColor"
          :font-size="sku.skuImg.leftBottomTag[0].fontSize"
        >
          {{ sku.skuImg.leftBottomTag[0].tag }}
        </tag>
      </div>
    </div>
    <div class="good-price">
      <div v-if="ssu.ssuPrice.priceShield" class="price-shield">
        {{ ssu.ssuPrice.priceShieldText }}
      </div>
      <!-- 价格部分 -->
      <div v-else class="price">
        <!-- 商品单价 -->
        <p class="unit-price">
          <span class="prefix-price">{{ unitPrice.prefix }}</span>
          <span class="value">{{ unitPrice.price }}</span>
          <span v-if="ssu.ssuPrice.unitPrice" class="unit"
            >/{{ unitPrice.unit }}</span
          >
          <!-- 划线价 -->
        </p>
      </div>
      <div class="tags">
        <tag
          has-border
          has-background
          :primary-color="ssu.ssuTags[0].textColor"
          :secondary-color="ssu.ssuTags[0].frameColor"
          :corner-radius="ssu.ssuTags[0].cornerRadius"
          :bg-color="ssu.ssuTags[0].backgroundColor"
          :font-size="ssu.ssuTags[0].fontSize"
        >
          {{ ssu.ssuTags[0].tag }}
        </tag>
      </div>
    </div>
    <!-- 加购按钮部分 -->
    <div class="operator-wrapper">
      <new-operator
        :btn-text="'加入购物车'"
        show-simple-count
        :ssu="ssu"
        :is-hint="ssu.is_hint"
        :btn-width="1.42"
        :show-can-not-buy="false"
        :bg-start-color="'#FF790B'"
        :bg-end-color="'#FF4636'"
        :icon-color="'rgb(255, 70, 53)'"
        :font-size="0.22"
        @goDetail="onGoSpike(ssu)"
      />
    </div>
  </div>
</template>
<script>
import Tag from '@/common/widgets/good_tag'
import NewOperator from '@/common/widgets/newOperator'
import GoodImage from '@/common/widget/GoodImage/index.vue'
export default {
  components: {
    Tag,
    NewOperator,
    GoodImage
  },
  props: {
    module: {
      type: Object,
      default: () => ({})
    },
    sku: {
      type: Object,
      default: () => ({})
    },
    ssu: {
      type: Object,
      default: () => ({})
    },
    onGoSpike: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    unitPrice() {
      const approximateShow = this.ssu.ssuPrice.isShowWeightUnitPrice === 1
      return {
        prefix: approximateShow ? '约￥' : '￥',
        price: this.ssu.ssuPrice[
          approximateShow ? 'weightUnitPrice' : 'unitPrice'
        ],
        unit: this.ssu.ssuPrice[
          approximateShow ? 'weightPriceUnit' : 'priceUnit'
        ]
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.seckill-good {
  display: flex;

  width: 1.78rem;

  flex-direction: column;
  align-items: center;
  &-image {
    position: relative;
    .image {
      overflow: hidden;

      border-radius: 0.16rem;
    }
    .img-tag {
      position: absolute;
      top: 0;
      right: 0;

      padding: 0.02rem 0.12rem;

      background-color: #ff0000;
      border-radius: 0.16rem 0.16rem 0.16rem 0.04rem;
      @include text(0.2rem, #fff);
    }
    .img-leftBottomTag {
      position: absolute;
      bottom: 0.04rem;
      left: 0.04rem;
    }
  }
  .good-price {
    color: #f03100;
    .prefix-price,
    .unit {
      font-size: 0.2rem;
    }
    .value {
      font-size: 0.26rem;
      font-weight: 600;
    }
  }
}
.tags {
  display: flex;

  overflow: hidden;

  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
</style>
